// extracted by mini-css-extract-plugin
export var body = "subAccordion-module--body--abe0d";
export var cross = "subAccordion-module--cross--82a39";
export var open = "subAccordion-module--open--cebf7";
export var subAccordion = "subAccordion-module--subAccordion--e613c";
export var titleButton = "subAccordion-module--titleButton--20f5c";